import { useEffect, lazy, Suspense } from 'react';
import { Box } from '@mui/material';
import { Container } from '~/content/components/Container';
// import Customer from './customer';
// import Contact from './contact';
const Customer = lazy(() => import('./customer.tsx'));
const Contact = lazy(() => import('./contact.tsx'));

import { trackPageview } from '~/utils/plausible';
import { useTheme } from '@mui/material/styles';

const references = (): JSX.Element => {
	const theme = useTheme();

	useEffect(() => {
		trackPageview();
	}, []);

	return (
		<Box>
			{/* <Container >
        <Hero />
      </Container>

     <Container  >
        <Partners />
       </Container> */}

			<Container>
				<Customer />
			</Container>

			<Box bgcolor={theme.palette.primary.light} pt={{ xs: 3, md: 5 }} pb={{ xs: 0, md: 2 }}>
				<Container>
					<Contact />
				</Container>
			</Box>
		</Box>
	);
};
export default references;

{
	/* <Box>
<Box
  position={'relative'}
  sx={{
    backgroundColor: theme.palette.alternate.main,
    backgroundImage: `linear-gradient(120deg, ${theme.palette.background.paper} 0%, ${theme.palette.alternate.main} 100%)`,
    marginTop: -13,
    paddingTop: 13,
  }}
>
  <Container zIndex={3} position={'relative'}>
    <Container marginLeft={'0 !important'}>
      <Headline />
    </Container>
  </Container>
  <Box
    component={'svg'}
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 1920 100.1"
    width={1}
    marginBottom={-1}
    position={'relative'}
    zIndex={2}
  >
    <path
      fill={theme.palette.background.paper}
      d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
    ></path>
  </Box>
</Box>
<Box position={'relative'} zIndex={3} marginTop={{ xs: 0, md: -22 }}>
  <Container>
    <Partners />
  </Container>
</Box>
<Container>
  <Stories />
</Container>
<Box bgcolor={theme.palette.alternate.main}>
  <Container>
    <Contact />
  </Container>
</Box>
</Box> */
}
